import FunnelStep from './FunnelStep';

export default FunnelStep;
